import React from 'react';
import { useTranslation } from 'react-i18next';
import { FilterPipelineFilter } from 'record-it-components/hooks/useFilterPipeline/useFilterPipeline';
import { TextInput } from 'record-it-components/input/TextInput/TextInput';
import { ConstructionSite } from '../../classes/entities/ConstructionSite/constructionSiteTypes';
import { ConstructionSiteUtils } from '../../classes/entities/ConstructionSite/ConstructionSiteUtils';

export const constructionSiteTextFilter: FilterPipelineFilter<
  ConstructionSite,
  string
> = {
  defaultValue: '',
  filter: (item, value) => {
    return ConstructionSiteUtils.containsSearchText(item, value);
  },
  Component: ({ value, setValue }) => {
    const { t } = useTranslation();

    return (
      <TextInput
        value={value}
        label={t('filters.constructionSiteTextFilter.label')}
        onInput={setValue}
        data-testid="constructionSiteTextFilter.Input"
      ></TextInput>
    );
  }
};
